export default {
  disclaimerColor: 'var(--black)',
};

